import React from 'react';

const WhatsappIntegration = () => {
  return (
    <div>
      <h3 style={{marginTop:'40px'}}>Connected to WhatsApp!</h3>
      <p style={{ fontSize: '14px', textAlign: 'left', width: '95%', marginTop: '20px', color: '#FFF' }}>
      </p>
    </div>
  );
};

export default WhatsappIntegration;
